export const AutoCheckFeedbackItemSourceFragment = gql`
  fragment AutoCheckFeedbackItemSourceFragment on AutoCheckFeedbackItemSource {
    id
    sourceType
    sourceFilePageNumber
    sourceFile {
      id
      name
    }
  }
`

export const AutoCheckFeedbackItemBaseFragment = gql`
  fragment AutoCheckFeedbackItemBaseFragment on AutoCheckFeedbackItemBase {
    id
    feedbackText
    severity
    sourceRuleType
    createdAt
    resolvedAt
  }
`

export const AutoCheckFeedbackItemFragment = gql`
  fragment AutoCheckFeedbackItemFragment on AutoCheckFeedbackItem {
    id
    createdAt
    feedbackText
    howResolved
    isAddedAsPlanReviewComment
    isAttachedToLatestApplicationReviewRound
    isSourceFileOnMostRecentPlansSet
    markedAsNotApplicableAt
    reasonWhyMarkedAsNotApplicable
    resolvedAt
    reviewType
    severity
    sourceRuleType
    status
    attachedApplicationReviewRecordTask {
      id
      ownerUser {
        ...UserDataFragment
      }
    }
    codeBookItem {
      ...CodeBookItemOptionFragment
    }
    markedAsNotApplicableByUser {
      ...UserDataFragment
    }
    resolvedByUser {
      ...UserDataFragment
    }
    sourceFile {
      ...AutoCheckFeedbackItemSourceFragment
    }
    createdByAutoCheckExecution {
      record {
        uuid
      }
    }
  }
`

export const AutoCheckExecutionFragment = gql`
  fragment AutoCheckExecutionFragment on AutoCheckExecution {
    id
    autoCheckFeedbackItems {
      ...AutoCheckFeedbackItemFragment
    }
  }
`

export const AutoCheckFeedbackUpdateFragment = gql`
  fragment AutoCheckFeedbackUpdateFragment on AutoCheckFeedbackUpdate {
    executionId
    isDone
    feedback {
      ...AutoCheckFeedbackItemBaseFragment
    }
  }
`
